import React from "react";

function Card({ stats }) {
  return (
    <div className="row g-3 mb-4 modern-stat-row">
      {/* TOTAL LEADS */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-danger flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Total Leads</p>
                <h3>{stats?.totalLeads || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-users" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* CONVERTED */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-success flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Contacted</p>
                <h3>{stats?.contacted || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-phone-call" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-success flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Contacted</p>
                <h3>{stats?.contacted || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-check" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div> */}

      {/* PENDING */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-warning flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Pending Leads</p>
                <h3>{stats?.pending || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-clock" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* CONVERSION */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-info flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Conversion %</p>
                <h3>
                  {stats?.totalLeads > 0
                    ? ((stats.converted / stats.totalLeads) * 100).toFixed(1)
                    : 0}
                  %
                </h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-percentage" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* TOTAL REVENUE */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-success-light flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Total Revenue</p>
                <h3>₹ {stats?.totalRevenue || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-currency-rupee" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* TOTAL PAYMENTS */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-primary flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Total Payments</p>
                <h3>{stats?.totalPayments || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-credit-card" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* PAID */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-paid flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Paid Payments</p>
                <h3>{stats?.paidPayments || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-circle-check" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>

      {/* PENDING PAYMENT */}
      <div className="col-xl-3 col-sm-6 d-flex">
        <div className="card modern-stat-card stat-pending flex-fill">
          <div className="card-body">
            <div className="stat-top">
              <div>
                <p>Pending Payments</p>
                <h3>{stats?.pendingPayments || 0}</h3>
              </div>

              <div className="stat-icon">
                <i className="ti ti-hourglass" />
              </div>
            </div>

            <div className="stat-wave"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
